// PopupSeparator.jsx

import React from 'react';

// CSS
import './PopupSeparator.css';

/**
 * PopupSeparator
 * 
 * Renders a separator line within a popup, styled according to the current theme.
 *  
 *
 * @returns {ReactNode} - PopupSeparator.
 */
const PopupSeparator = React.memo(() => {

    // ----- RENDER ----- //

    return (
        <div
          className="popup-separator-container"
        ></div>
    );

});

// Dev Tools
PopupSeparator.displayName = 'PopupSeparator';

export default PopupSeparator;
